<template>
  <v-app style="background-color: #ffffff;">
    <vue-headful :title="this.title" />
    <v-main>
      <navigation v-if="showNavigation" :userRoles="userRoles" :displayName="meDisplayName"></navigation>
      <v-container fluid>
        <global-error></global-error>
        <global-success></global-success>
        <router-view></router-view>
        <stripe-conditions-snackbar v-model="showStripeDialog" @onAgree="onStripeTermsAgreed"></stripe-conditions-snackbar>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import { mapGetters } from 'vuex';
import jwtDecode from 'jwt-decode';
import StripeConditionsSnackbar from '@/components/StripeConditionsSnackbar.vue';
import { setTheme } from './mixins/vuetifyConfig.mixins';
import { initBookingChannel, bookingChannelComputed } from './mixins/bookingChannel.mixins';
import { initLocale } from './mixins/language.mixins';

import Navigation from './components/Navigation.vue';
import GlobalError from './components/GlobalError.vue';
import GlobalSuccess from './components/GlobalSuccess.vue';

export default {
  name: 'App',
  data: () => ({
    displayDrawer: false,
    showStripeDialog: false,
  }),
  components: { GlobalError, GlobalSuccess, Navigation, StripeConditionsSnackbar },
  mixins: [initBookingChannel, setTheme, initLocale, bookingChannelComputed],
  computed: {
    ...mapGetters({
      idToken: 'authentication/idToken',
      areTermsAccepted: 'stripe/areTermsAccepted',
    }),
    showNavigation() {
      if (!this.$route || !this.$route.meta) {
        return false;
      }
      return this.$route.meta.hasNavigation || false;
    },
    title() {
      return this.$t('head.title', { companyName: this.companyName });
    },
    meDisplayName() {
      const decodedToken = jwtDecode(this.idToken);
      return `${decodedToken.email}`;
    },
    userRoles() {
      const decoded = jwtDecode(this.idToken);
      if (decoded) return decoded.roles || [];
      return [];
    },
  },
  mounted() {
    if (!this.areTermsAccepted) {
      this.showStripeDialog = true;
    }
  },
  methods: {
    onStripeTermsAgreed() {
      this.$store.dispatch('stripe/acceptTermsAndConditions');
    },
  },
};
</script>
<style lang="scss">
@import './styles/global.scss';
</style>

<style lang="scss">
html, body {
  font-family: 'FiraSans', sans-serif;
}

#app {
  font-family: 'FiraSans', sans-serif;
  color: #2c3e50;
}

@font-face {
  font-family: "FiraSans";
  src: local("FiraSans"),
  url(./fonts/FiraSans-Regular.ttf) format("truetype");
}
#nav {
  padding: 30px;
  a {
    font-weight: bold;
    color: #2c3e50;
    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
